/*
 *
 * LoginPage constants
 *
 */

export const DEFAULT_ACTION = '/LoginPage/DEFAULT_ACTION';
export const OTP_REQUEST_SUCCESS = '/LoginPage/OTP_REQUEST_SUCCESS';
export const CHANGE_LOGIN_FORM = '/LoginPage/CHANGE_LOGIN_FORM';
export const CHANGE_SIGNUP_FORM = '/LoginPage/CHANGE_SIGNUP_FORM';
export const CHANGE_FORGOT_FORM = '/LoginPage/CHANGE_FORGOT_FORM';
export const FORGOT_OTP_SUCCESS = '/LoginPage/FORGOT_OTP_SUCCESS';
export const OTP_SUBMIT_SUCCESS = '/LoginPage/OTP_SUBMIT_SUCCESS';
export const CHANGE_SET_PASSWORD_FORM = '/LogionPage/CHANGE_SET_PASSWORD_FORM';
export const SET_PASSWORD_SUCCESS = '/LoginPage/SET_PASSWORD_SUCCESS';
export const SHOW_LOGIN_FORM = '/LoginPage/SHOW_LOGIN_FORM';
export const LOGIN_ERROR = '/LoginPage/LOGIN_ERROR';
export const LOGIN_SUCCESS = '/LoginPage/LOGIN_SUCCESS';
// export const LOGIN = '/LoginPage/LOGIN';

export const PRE_BROWSER_PAYLOAD = {
  app_version: 1.0,
  client_key: 'client_key',
  client_name: 'WebBrowser',
  client_version: 'WebBrowser',
};
export const MANDATORYFIELDS_SIGNUP = ['name', 'email', 'phone', 'password'];
export const MANDATORYFIELDS_FORGOT_PASSWORD = ['otp', 'password', 'confirmPassword'];



// WEBPACK FOOTER //
// client/containers/LoginPage/constants.js